<template>
  <ValidationObserver v-if="addressData !== undefined" class="col-12 row">
    <b-col cols="12" class="mt-1 mb-1">
      <b-form-group>
        <label for="name">ที่อยู่ <span class="text-danger">*</span></label>
        <ValidationProvider rules="required" name="ที่อยู่" v-slot="{ errors }">
          <b-form-textarea
            id="address1"
            v-model="addressData.address1"
            placeholder="กรุณากรอก ที่อยู่"
          />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-form-group>
    </b-col>

    <b-col cols="12" md="3" class="mt-1 mb-1">
      <b-form-group>
        <label for="nameEn">ตำบล <span class="text-danger">*</span></label>
        <ValidationProvider rules="required" name="ตำบล" v-slot="{ errors }">
          <!-- <b-form-input
            id="tumbon"
            v-model="addressData.tumbon"
            placeholder="กรุณากรอก ตำบล"
          /> -->
          <vue-autosuggest
            :v-model="addressData.tumbon"
            :value="addressData.tumbon"
            :suggestions="filteredOptions"
            :limit="limit"
            :input-props="inputProps"
            class=""
            @selected="onSelected"
            @input="onInputChange"
            @change="onItemChange"
            :get-suggestion-value="getSuggestionValue"
          >
            <template slot-scope="{ suggestion }">
              <span class="my-suggestion-item">{{
                suggestion.item.label
              }}</span>
            </template>
          </vue-autosuggest>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-form-group>
    </b-col>

    <b-col cols="12" md="3" class="mt-1 mb-1">
      <b-form-group>
        <label for="createDate">อำเภอ</label>
        <ValidationProvider name="อำเภอ" v-slot="{ errors }">
          <b-form-input
            id="ampher"
            v-model="addressData.ampher"
            placeholder="กรุณากรอก อำเภอ"
            readonly="readonly"
          />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-form-group>
    </b-col>

    <b-col cols="12" md="3" class="mt-1 mb-1">
      <b-form-group>
        <label for="createDate">จังหวัด </label>
        <ValidationProvider name="จังหวัด" v-slot="{ errors }">
          <b-form-input
            id="province"
            v-model="addressData.province"
            placeholder="กรุณากรอก จังหวัด"
            readonly="readonly"
          />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-form-group>
    </b-col>

    <b-col cols="12" md="3" class="mt-1 mb-1">
      <b-form-group>
        <label for="zipcode">รหัสไปรษณีย์ </label>
        <ValidationProvider name="รหัสไปรษณีย์" v-slot="{ errors }">
          <b-form-input
            id="contactFax"
            v-model="addressData.zipcode"
            placeholder="กรุณากรอก รหัสไปรษณีย์"
            readonly="readonly"
          />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-form-group>
    </b-col>
  </ValidationObserver>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormDatepicker,
  BFormTimepicker,
  BFormFile,
} from "bootstrap-vue";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

import { VueAutosuggest } from "vue-autosuggest";

import * as digitalIdUtilStore from "@/store/api/digitalIdUtils/index.js";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    extend,
    VueAutosuggest,
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "tumbon",
        class: "form-control",
        placeholder: "ตำบล",
      },
      limit: 10,
    };
  },
  created() {
    const _this = this;

    digitalIdUtilStore
      .getAllSubDistrictAutocomplete()
      .then((response) => {
        //console.log('response', response)
        _this.datasuggest = response.data.data;
        console.log("datasuggest", _this.datasuggest);
      })
      .catch((error) => {
        console.log("error", error);
      });
  },
  props: {
    addressData: {},
  },
  methods: {
    onSelected(option) {
      const _this = this;

      digitalIdUtilStore
        .getAddressBySubDistrictCode(option.item.value)
        .then((response) => {
          console.log("response", response);
          _this.$emit("handleSetAddress", response.data.data);
        })
        .catch((error) => {
          console.log("error", error);
        });

      //   this.company.companyDetail = option.item.label;
      //   this.company.compId = option.item.value;
      //   console.log(option);
      //   // get company address detial
      //   companyStore
      //     .getAddressDetail(option.item.value)
      //     .then((response) => {
      //       _this.company.address = response.data.data;
      //     })
      //     .catch((error) => {
      //       console.log("error", error);
      //     });
    },
    onInputChange(text) {
      const _this = this;

      if (text === "" || text === undefined) {
        return;
      }

      if (text.length < 3) {
        return;
      }

      const filteredOptions = this.datasuggest
        .filter((item) => item.label.indexOf(text) > -1)
        .slice(0, this.limit);
      _this.filteredOptions = [
        {
          data: filteredOptions,
        },
      ];
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.label;
    },
    onItemChange(value) {
      //console.log('onItemChange', value.target.value)
      const _this = this

      digitalIdUtilStore
        .getValidateTumbolName(value.target.value)
        .then((response) => {
          //console.log('validate response', response)

          if (response.data.success === false) {
            const address = {
              districtCode: "",
              districtName: "",
              provinceCode: "",
              provinceName: "",
              subDistrictCode: "",
              subDistrictName: "",
              zipcode: "",
            };
            _this.$emit("handleSetAddress", address);
          }
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>
